import { atom, selector } from 'recoil'

export const cameraState = atom({
    key: 'camera',
    default: false,
})

export const imageState = atom({
    key: 'image',
    default: null,
})

export const locationState = atom({
    key: 'location',
    default: null,
})

export const selectedCategoryValueState = atom({
    key: 'selectedCategoryValue',
    default: null,
})

export const selectedCategoryTitleState = atom({
    key: 'selectedCategoryTitle',
    default: null,
})

export const categoryPointsState = atom({
    key: 'categoryPoints',
    default: null,
})

export const categoryIconState = atom({
    key: 'categoryIcon',
    default: null,
})

export const modalState = atom({
    key: 'modal',
    default: false,
})

export const submittedPhotoState = selector({
    key: 'submittedPhoto',
    get: ({ get }) => {
        const image = get(imageState)
        const value = get(selectedCategoryValueState)
        const title = get(selectedCategoryTitleState)
        const icon = get(categoryIconState)
        const points = get(categoryPointsState)
        return { image, value, title, icon, points }
    },
})

export const allPhotosState = atom({
    key: 'allPhotos',
    default: [],
})

export const showNavState = atom({
    key: 'showNav',
    default: true,
})

export const userState = atom({
    key: 'user',
    default: {
        first_name: '',
        last_name: '',
        suffix: '',
        email: '',
        phone_number: '',
        user_photo: '',
        username: '',
        gender: '',
        industry: '',
        job_title: '',
        bio: '',
        location: {
            street_address: '',
            street_address_2: '',
            city: '',
            state: '',
            zip: '',
            country: '',
        },
        stats: {
            level: 1,
            points: 0,
            homes_tagged: 0,
            photos_uploaded: 0,
            pending_points: 0,
            redeemed_points: 0,
            pending_rewards: '',
            past_rewards: '',
        },
        social_media: {
            facebook: '',
            twitter: '',
            linkedin: '',
        },
        account: {
            isVerified: false,
            active: true,
        },
    },
})
